import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { XCircle, ArrowLeft } from 'lucide-react';

const SubscriptionCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 to-slate-900 flex items-center justify-center p-4">
      <div className="bg-black/40 border border-white/10 rounded-xl p-8 max-w-md w-full text-center">
        <div className="w-20 h-20 rounded-full bg-gray-500/20 flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-12 h-12 text-gray-400" />
        </div>
        <h2 className="text-2xl font-bold mb-2">Checkout Cancelled</h2>
        <p className="text-gray-400 mb-6">
          No worries! Your account hasn't been charged. You can upgrade anytime.
        </p>
        <div className="space-y-3">
          <Button onClick={() => navigate('/pricing')} className="w-full">
            View Plans
          </Button>
          <Button onClick={() => navigate('/')} variant="outline" className="w-full">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCancel;
